// 
var WechatGiftRedirector = xClass("WechatGiftRedirector", BaseRedirector)
WechatGiftRedirector.prototype.getName = function () {
    var self = this
    return "wechatGift"
}
WechatGiftRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
WechatGiftRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    var um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }
    if (um.wxGifts && um.wxGifts.length > 0){
        // 本地有未展示的数据了
        return false;
    }
    
    if (global.mini && mini.getPlatform() === MiniPlatform.wechatGame) {
        console.log("[gift] WechatGiftRedirector start check")

        let http = GetWxGiftHttp.new();
        http.addEventListener(Events.kComplete, (evt) => {
            //后端不在维护giftIdList字段
            if(window.EmailManager) {
                EmailManager.getInstance().forceGetInfo();
            }
            return;
            let giftList = evt.data.giftIdList
            if (giftList == null){
                return
            }

            if ($len(giftList) > 0){
                // giftList.forEach(giftId => {
                //     if (giftId){
                //         um.wxGifts.push(giftId)
                //     }
                // });

                // console.log("[gift] WechatGiftRedirector update wxGifts", um.wxGifts)
            }
        })
        http.addEventListener(Events.kError, (evt = {}) => {

        })
        http.load();

        return true
    }
    return false
}
module.exports = WechatGiftRedirector
